import React from 'react';
import styled from 'styled-components/macro';


const AngleIcon = (props) => {
    return (
        <Container {...props}>
            <svg xmlns="http://www.w3.org/2000/svg" width="33.77" height="61.554" viewBox="0 0 33.77 61.554">
                <polygon points="33.77 58.561 5.986 30.777 33.77 2.993 30.777 0 0 30.777 30.777 61.554 33.77 58.561"/>
            </svg>
        </Container>
    
    );
};


export default AngleIcon;


const Container = styled.span`
    display: inline-block;
    vertical-align: middle;
    height: 1em;
    
    transform: ${props => props.flip ? 'scaleX(-1)' : 'scaleX(1)'};
    
    svg {
        height: 100%;
        width: auto;
        fill: currentColor;
        stroke: currentColor;
        stroke-width: .025em;
    }
`;
